import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Span from 'src/components/ui/Span';
import DropdownWithAnt from 'src/components/ui/DropdownWithAnt';
import logger from 'src/utils/logger';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormPlaceholder } from 'src/helpers/multilingualHelper';
import { getTranslatedCountries } from 'src/constants/countryTranslations';
import { normalize } from 'src/helpers/normalizeHelper';


const CountryClientForm = ({ elementId, label, required, placeholder, options, setCountry, errors, control, config, onChange: onChangeCustom, value, setDisabled }) => {
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const { setValue } = useForm();
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayPlaceholder = getFormPlaceholder(placeholder, currentLanguage);
    useEffect(() => {
        const dropdownOptions = getTranslatedCountries(currentLanguage);
        setDropdownOptions(dropdownOptions);
    }, [label, options, currentLanguage]);
    return (
        <div className="relative inline-block w-full">
            <label htmlFor={elementId} className="block mb-2 text-sm text-gray-700">
                {displayLabel}{required && '*'}
            </label>
            <Controller
                name={elementId}
                control={control}
                rules={{ required: required }}
                render={({ field }) => {
                    if (!field.value && value) {
                        field.onChange(value);
                        setValue(elementId, value)
                        if (config?.dbKey) {
                            setCountry(value);
                            setDisabled(false)
                            logger.log(value)
                        }
                    }
                    return (
                        <DropdownWithAnt
                            {...field}
                            ref={field.ref}
                            filterOption={(input, option) =>
                                normalize(option?.label?.toString() || '').includes(
                                  normalize(input)
                                )
                              }
                            mode={config.isMultiple ? 'multiple' : undefined}
                            options={dropdownOptions}
                            placeholder={displayPlaceholder}
                            onChange={(e) => {
                                onChangeCustom(elementId, null, e);
                                field.onChange(e);
                                if (config?.dbKey) {
                                    setCountry(e);
                                }
                            }}
                            value={field.value}
                        />
                    )
                }}
            />
            {errors[elementId] && <Span className="text-FailRed400 text-xxs">{errors[elementId].message ? errors[elementId].message : t('form.thisFieldRequired')}</Span>}
        </div>
    );
};

export default CountryClientForm;
